import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Spinner } from 'react-bootstrap';
import CodeEditor from '@uiw/react-textarea-code-editor';
import { getFields } from '../../api/fields';
import { addProductField } from '../../api/products';
import { NotificationContext } from '../../components/notification-provider';
import { useContext } from 'preact/hooks';
import { getProductByCode, getProductFields } from '../../api/products';

export default function AddProductFieldModal ({
    show = true,
    productKey,
    product,
    onHide,
    ...props
}) {

    const [fields, setFields] = useState([]);
    const [fieldsLoading, setFieldsLoading] = useState(true);
    const [productField, setProductField] = useState({});
    const { addNotification } = useContext(NotificationContext);
    const [saveProductFieldLoading, setSaveProductFieldLoading] = useState(false);

    const loadFields = () => {
        setFieldsLoading(true);

        getFields().then(response => {
            setFields(response.data.data);
            setFieldsLoading(false);
        });
    };

    const handleChange = (e) => {
        const { id, value } = e.target;

        setProductField({ ...productField, [id]: value });
    }

    const handleSave = () => {

        setSaveProductFieldLoading(true);

        addProductField(product.code, productField).then(response => {
            addNotification('Le champ a été ajouté avec succès', 'success');
            setProductField({});
        }).catch(error => {
            addNotification('Une erreur est survenue lors de l\'ajout du champ', 'danger');
            console.log('error', error);
        }).finally(() => {
            onHide();
            setSaveProductFieldLoading(false);

        });
    }

    useEffect(() => {
        loadFields();
    }, []);


    return <>
        <Modal show={show} onHide={onHide} {...props}>
            <Modal.Header closeButton>
                <Modal.Title>Ajouter un champ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form id="form-add-product-field">
                    <Form.Group className="mb-3" controlId="field_key">
                        <Form.Label>Champs</Form.Label>
                        <Form.Control as="select" onChange={handleChange} >
                            <option>Selectionnez un field</option>
                            {fieldsLoading ? <option>Chargement...</option> : null}
                            {fields.map((field) => {
                                return <option value={field.key} selected={productField.key === field.key} >
                                    {field.label} - ({field.label})
                                </option>
                            })}
                        </Form.Control>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="config
                    ">
                        <Form.Label>Config</Form.Label>
                        <CodeEditor
                            value={productField.config}
                            onChange={handleChange}
                            id="config"
                            placeholder="Please enter JS code."
                            padding={15}
                            style={{
                                fontSize: 14,
backgroundColor: "#f1f1f1",
                                backgroundColor: "#f1f1f1",
                                fontFamily: "ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace",
                            }} />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <Button variant="secondary" onClick={onHide}>
                    Fermer
                </Button>

                <Button form="form-add-product-field" variant="primary" onClick={handleSave} disabled={saveProductFieldLoading}>
                    {saveProductFieldLoading ? <Spinner animation="border" size="sm" /> : null}
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Modal>
    </>
}